module.exports = __webpack_public_path__ + "static/media/bytt-nn-17.eda1b68b.mp3";